import {
    AuthPage,
    isCfeConnectPage,
    isCfeDiagnosticPage,
    isCfeInventoryPage,
    isSettingsPage,
    isUploadsPage,
    Module,
    Page,
} from "@flexidao/dto";
import { ReactElement, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
    AppLoading,
    authPaths,
    UserInitializedComponent,
    useTenantDisplay,
} from "@flexidao/ui-lib";

const Redirect = (): ReactElement => {
    const navigate = useNavigate();
    const displaySettings = useTenantDisplay();
    const homepage = displaySettings.homepage;
    const module = getModuleFromPage(homepage);

    useEffect(() => {
        const path =
            homepage && module
                ? `/app/${module}/${homepage}`
                : authPaths[AuthPage.NoDisplayOptions];
        navigate(path);
    });
    return <></>;
};

export const HomepageRedirect = (): ReactElement => (
    <UserInitializedComponent skeleton={<AppLoading />} content={<Redirect />} />
);

const getModuleFromPage = (page: Page | null): string | null => {
    if (page === null) {
        return null;
    }

    if (isCfeConnectPage(page)) {
        return Module.CfeConnect;
    }
    if (isCfeDiagnosticPage(page)) {
        return Module.CfeDiagnostic;
    }
    if (isSettingsPage(page)) {
        return Module.Settings;
    }
    if (isCfeInventoryPage(page)) {
        return Module.CfeInventory;
    }
    if (isUploadsPage(page)) {
        return Module.Uploads;
    }

    return null;
};
